import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getAllCompletedKorba,
  getAllKorba,
  getAllKorbaAssistance,
  getAllKorbaTypes,
  getKorbaHomePage,
} from "../../../apis/actions/korba.actions";
import {
  getAllProjectsTypes,
  getHomeProjects,
  getSeasonalProjects,
} from "../../../apis/actions/projects.actions";
import { AppDispatch, RootState } from "../../../apis/store";
import SearchWithSelect from "../../../biblio/SearchWithSelect";
import CaseList from "./CaseList";
import {
  getAllGeneralDonations,
  getCompletedGeneralDonation,
  getDonationTypes,
  getGeneralDonationTypes,
  getHomePageGeneralDonations,
} from "../../../apis/actions/generalDonations.actions";
// TEMPORARY: search/filter bar hidden on the homepage cases section (tabs stay visible) — REQUESTED BY CLIENT
const SHOW_SEARCH_HEADER: boolean = false;

const CasesOverview = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const {
    homeSeasonalProjects,
    statusProjects,
    projectTypes,
    seasonalProjects,
  } = useSelector((state: RootState) => state?.projects);

  const {
    donationTypes,
    completedGeneralDonations,
    statusGeneralDonation,
    generalDonationHomePage,
    generalDonations,
    generalDonationTypes,
  } = useSelector((state: RootState) => state?.generalDonations);

  const {
    korbaHomePage,
    korbas,
    korbaTypes,
    korbaAssitances,
    completedkorba,
    statusKorba,
  } = useSelector((state: RootState) => state?.korbas);

  //for Korba Projects
  const projectsKorba = [...korbaHomePage].sort((a: any, b: any) => {
    return a.sequence - b.sequence;
  });
  const location = useLocation();
  const [isActive, setIsActive] = useState(location?.state?.type ?? "المشاريع");
  const [searchState, setSearchState] = useState<any>({});

  const tabs = ["المشاريع", "تفريج كرب", "التبرع العام"];

  const getProjects = async () => {
    await dispatch(getHomeProjects());
    await dispatch(getSeasonalProjects());
    await dispatch(getAllProjectsTypes());
  };

  const getGeneralDonations = async () => {
    await dispatch(getHomePageGeneralDonations());
    await dispatch(getAllGeneralDonations());
    await dispatch(getGeneralDonationTypes());
    await dispatch(getDonationTypes());
    await dispatch(getCompletedGeneralDonation());
  };

  const getKorbas = async () => {
    await dispatch(getKorbaHomePage());
    await dispatch(getAllKorba());
    await dispatch(getAllKorbaTypes());
    await dispatch(getAllKorbaAssistance());
    await dispatch(getAllCompletedKorba());
  };

  useEffect(() => {
    handleToggle(isActive);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    homeSeasonalProjects,
    seasonalProjects,
    projectTypes,
    isActive,
    korbaHomePage,
    korbas,
    korbaTypes,
    korbaAssitances,
    completedkorba,
    donationTypes,
    completedGeneralDonations,
    statusGeneralDonation,
    generalDonationHomePage,
    generalDonations,
    generalDonationTypes,
  ]);

  const handleToggle = (tabName: string, isCompleted: boolean = false) => {
    switch (tabName) {
      case "المشاريع":
        if (statusProjects !== "succeeded") {
          getProjects();
        }
        setSearchState({
          items: homeSeasonalProjects,
          initialItems: homeSeasonalProjects,
          options: [
            ...projectTypes.map((option: any) => ({
              label: option.name,
              value: option.id,
            })),
          ],
          fieldsName: ["project_name", "brief"],
          typeFieldName: "request_type_id",
          placeholderSelect: "اختر نوع المشروع",
          url: "/general-projects",
          toFilter: false,
          title: t("cases.allCases"),
          type: isActive,
          filteredProjects: homeSeasonalProjects,
          loading: statusProjects === "idle",
        });

        break;

      case "تفريج كرب":
        if (statusKorba !== "succeeded") {
          getKorbas();
        }

        setSearchState({
          items: isCompleted ? completedkorba : korbas,
          initialItems: isCompleted ? completedkorba : projectsKorba,
          options: [
            ...korbaAssitances.map((option: any) => ({
              label: option.name,
              value: option.id,
            })),
          ],
          fieldsName: ["summary"],
          typeFieldName: "assistance_id",
          showIscompletedButton: true,
          titleBtnCompleted: isCompleted ? "كرب تنتظر دعمكم" : "المكتملة",
          placeholderSelect: "اختر نوع الحالة",
          url: "/korbas",
          toFilter: false,
          title: "عرض كل الحالات",
          type: isActive,
          types: korbaTypes,
          isCompleted: isCompleted,
          filteredProjects: projectsKorba,
          loading: statusKorba === "idle",
        });

        break;

      case "التبرع العام":
        if (statusGeneralDonation !== "succeeded") {
          getGeneralDonations();
        }
        setSearchState({
          items: isCompleted ? completedGeneralDonations : generalDonations,
          initialItems: isCompleted
            ? completedGeneralDonations
            : generalDonationHomePage,

          options: [
            ...generalDonationTypes.map((option: any) => ({
              label: option.name,
              value: option.id,
            })),
          ],
          fieldsName: ["summary", "name"],
          typeFieldName: "request_type_id",
          url: "/general-donations",
          placeholderSelect: "اختر نوع التبرع العام",
          toFilter: false,
          title: " عرض كل التبرعات العامة",
          type: isActive,
          filteredProjects: generalDonationHomePage,
          loading: statusGeneralDonation === "idle",
          titleBtnCompleted: isCompleted ? "تبرعات  تنتظر دعمكم" : "المكتملة",
          isCompleted: isCompleted,
          showIscompletedButton: true,
          types: donationTypes,
        });

        break;

      default:
        break;
    }

    setIsActive(tabName);
  };

  return (
    <section className="takaful--cases-section">
      <div className="takaful--cases-header">
        <div className="takaful--cases-tabs">
          {tabs.map((el, index) => (
            <div
              className={`common--tab ${
                isActive === el ? "active" : "inactive "
              }`}
              onClick={() => handleToggle(el)}
            >
              {index === 2 ? "التبرعات العامة" : el}
            </div>
          ))}
        </div>
        {SHOW_SEARCH_HEADER && (
          <SearchWithSelect
            state={searchState}
            setFiltredList={(filtred, e) =>
              setSearchState({
                ...searchState,
                filteredProjects: filtred,
                toFilter: e,
              })
            }
            updateIsCompleted={() =>
              handleToggle(isActive, !searchState.isCompleted)
            }
          />
        )}
      </div>
      <CaseList state={searchState} startIndex={0} endIndex={4} />
    </section>
  );
};

export default CasesOverview;
